export default __webpack_public_path__ + "static/mazzola-d820105311d853661098b02f8a0574c7.jpg";